@if (!imInAuthRoute) {
  <core-header (menuToggled)="sidebar.onMenuToggled($event)"></core-header>
  <ngx-loading-bar color="#004aea" style="z-index: 20;" [fixed]="false" [includeSpinner]="true"></ngx-loading-bar>
  <div class="flex relative ">
    <core-sidebar class="" #sidebar></core-sidebar>
    <div class="flex-grow">
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <div class="flex-grow">
    <router-outlet></router-outlet>
  </div>
}
